/* eslint-disable @typescript-eslint/no-magic-numbers */
import { validatePesel } from '../validator/pesel.validator';
import toDateStringUtil from './toDateString.util';

const peselToBirthDateUtil = (pesel: string): string | null => {
  if (!validatePesel(pesel)) {
    return null;
  }

  const peselYear = parseInt(pesel.substring(0, 2), 10);
  const peselMonth = parseInt(pesel.substring(2, 4), 10);
  const day = parseInt(pesel.substring(4, 6), 10);

  const monthMappings = [
    { range: [1, 12], offset: 1900 },
    { range: [21, 32], offset: 2000 },
    { range: [41, 52], offset: 2100 },
    { range: [61, 72], offset: 2200 },
    { range: [81, 92], offset: 1800 },
  ];

  let year: number;
  let month: number;

  const mapping = monthMappings.find((m) => peselMonth >= m.range[0] && peselMonth <= m.range[1]);

  if (mapping) {
    year = mapping.offset + peselYear;
    month = peselMonth - (mapping.range[0] - 1);
  } else {
    return null;
  }

  const date = new Date(year, month - 1, day);

  return toDateStringUtil(date);
};

export default peselToBirthDateUtil;
